import React from "react";
import BottomSheet from "../../BottomSheet";
import Button from "../../Button";

interface CGMUploadLogsBottomSheetProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const CGMUploadLogsBottomSheet: React.FC<CGMUploadLogsBottomSheetProps> = ({
  show,
  onClose,
  onSubmit,
}) => {
  return (
    <BottomSheet
      show={show}
      title="Upload CGM Logs"
      handleClose={onClose}
      zIndex={60}
    >
      <div className="p-4">
        <p className="text-sm text-gray-500">
          Generate and upload diagnostic logs to help us troubleshoot any issues
          you may be experiencing.
        </p>

        <div className="flex gap-3 mt-4">
          <Button onClick={onClose} variant="outlined" rounded="full" fullWidth>
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            variant="contained"
            rounded="full"
            fullWidth
          >
            Upload Logs
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CGMUploadLogsBottomSheet;
